import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import fontUniOrConvertZawgyi from '/utils/fontUniOrConvertZawgyi';
import Hidden from '@material-ui/core/Hidden';
import Collapse from '@material-ui/core/Collapse';
import ReactHtmlParser from 'react-html-parser';
import VideoDetailTags from './VideoDetailTags';
import VideoDetailCategories from './VideoDetailCategories';
import { isMobile } from "react-device-detect";
import VideoDetailComments from "/components/VideoDetail/VideoDetailComments";

const styles = theme => ({
    root: {
      padding: '16px 0px'
    },
    btnStyle: {
        marginTop: 10,
        textTransform: 'capitalize', 
        fontWeight: 'bold', 
        fontSize: 16,
        color: '#fff'
    },
    expand: {
      transform: 'rotate(0deg)',
      marginLeft: 'auto',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
      }),
    },
    showMoreBtn: {
      fontSize: 14,
      textTransform: 'uppercase',
      padding: '10px 0px',
      color: '#a3a7a9'
    },
    
});

class VideoDetailCollapse extends React.Component {

  render() {
    const { classes, expanded, item, toggleBox, open, tagChips, routeName, videoType, asPath } = this.props;
    // console.log(videoType)
    let description = item.description;
    let descriptionLength = description != null ? description.length : null;
    let sliceDescription = description != null ? description.substr(0, 150) : null;
    let showAllDescription = description != null ? description.slice(150) : null;
    const tagAndCategories = () => (
      <>
        {tagChips.length != 0 && <VideoDetailTags routeName={routeName} tagChips={tagChips} />}
        {item.categories.length != 0 && <VideoDetailCategories videoType={videoType} categoryNames={item.categories} />}
      </>
    )
    const mobileCollapse = () => (<Collapse in={expanded} timeout="auto" unmountOnExit>
    <div className={classes.root}>
      <Typography component="div" variant="subtitle1" style={{ color: '#fff', opacity: 0.9, fontSize: 14, overflowWrap: 'break-word' }}>
        {ReactHtmlParser(fontUniOrConvertZawgyi(description))}
      </Typography>
      {tagAndCategories()}
      <VideoDetailComments asPath={asPath} />
    </div>
  </Collapse>)
 
    return(
      <React.Fragment>
        {isMobile ? 
          mobileCollapse() :
          <div>
            {/* ************************* mobile view ************************** */}
            <Hidden only={['lg', 'xl']}>
              {mobileCollapse()}
            </Hidden>
            {/************************* desktop view **************************/}
            <Hidden only={['sm', 'xs', 'md']}> 
              <Grid container spacing={16} direction="row" justify="center" alignItems="center">  
                  <Grid item xs={12} sm={12} md={12}>
                      <Typography component="div" variant="subtitle1" style={{ color: '#fff', paddingTop: 14, fontSize: 14 }}>
                          {ReactHtmlParser(fontUniOrConvertZawgyi(sliceDescription))}
                          {open && ReactHtmlParser(fontUniOrConvertZawgyi(showAllDescription))}
                      </Typography>
                      {
                        descriptionLength < 150 ?
                        tagAndCategories()
                        :
                        open && tagAndCategories()
                      }
                      {
                        descriptionLength > 150 && descriptionLength != null ?
                          <Button onClick={toggleBox} className={classes.showMoreBtn}>
                            {!open ? "Show More" : 'Show Less' }
                          </Button>
                          : null
                      }
                      <VideoDetailComments asPath={asPath} />
                  
                </Grid>
              </Grid>
            </Hidden>
            
          </div>
        }
       
      </React.Fragment>
      
    )
  }
}

VideoDetailCollapse.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(VideoDetailCollapse);

